<ion-item *ngIf="parent==null || (requestService.invite[parent] && requestService.invite[parent]!='Other')">
  <ion-label>{{label}}</ion-label>
  <ion-select (ionChange)="masterService.updateMaster(requestService.invite[master], category)"
    [(ngModel)]="requestService.invite[master]" [placeholder]="'Select '+ label" [interface]="'popover'">
    <ion-select-option *ngFor="let item of masterService.getLevel(level, category)"
      [value]="item.name">{{item.name}}</ion-select-option>
    <ion-select-option value="Other">Other</ion-select-option>
  </ion-select>
</ion-item>
<br *ngIf="parent==null || (requestService.invite[parent] && requestService.invite[parent]!='Other')">

<app-a-input [(variable)]="extraVariable.value" [label]="'Please mention your '+label"
  *ngIf="requestService.invite[master]=='Other' || requestService.invite[parent]=='Other'"></app-a-input>
<br *ngIf="requestService.invite[master]=='Other'">
<!-- 
name:{{extraVariable.name}}<br>
value: {{extraVariable.value}}<br> -->